import PropTypes from "prop-types";
import { getCurrentUser } from "../services/JwtService";
import {
    BEAUFTRAGTER,
    BETREIBER,
    FACHADMIN,
    LESER_BEHOERDE,
    LESER_ORGANISATION,
    SYSTEMADMIN,
    ZUST_SBA,
    ZUST_SBB,
    ZUST_SBD,
    ZUST_SBS,
} from "../consts/funktionaleRollen";

export const NOT_LOGGED_IN_CONDITION = ["NOT_LOGGED_IN"];
export const LOGGED_IN_CONDITION = ["LOGGED_IN"];

/**
 * Prüft, ob der currentUser eine der übergebenen Rollen hat.
 * @param roles
 * @returns {boolean|boolean|T}
 */
export function userHasAnyRole(roles) {
    const user = getCurrentUser();
    return (
        (user && checkForCondition(roles, LOGGED_IN_CONDITION)) ||
        (!user && checkForCondition(roles, NOT_LOGGED_IN_CONDITION)) ||
        (user && Array.isArray(user.funktionaleRollen) && user.funktionaleRollen.some((role) => roles.includes(role)))
    );
}

/**
 * Überprüft, ob die angegebenen Rollen die condition erfüllen
 * @param roles
 * @param condition
 * @returns {boolean} true, wenn roles identisch mit condition ist
 */
export function checkForCondition(roles, condition) {
    return JSON.stringify(roles) === JSON.stringify(condition);
}

userHasAnyRole.propTypes = {
    roles: PropTypes.arrayOf(
        PropTypes.oneOf([
            "NOT_LOGGED_IN",
            "LOGGED_IN",
            BETREIBER,
            BEAUFTRAGTER,
            LESER_ORGANISATION,
            ZUST_SBD,
            ZUST_SBB,
            ZUST_SBS,
            ZUST_SBA,
            LESER_BEHOERDE,
            FACHADMIN,
            SYSTEMADMIN,
        ])
    ).isRequired,
};
